<template>
  <div
    class="fx-tabs"
  >
    <div
      v-for="t in data"
      :key="t.value"
      :class="{ tab: true, active: cur === t.value }"
      @click="change(t)"
    >
      <span class="label">{{ t.label }}</span>
      <span class="mark"></span>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref, PropType, watch } from 'vue'

export default defineComponent({
  name: 'Tabs',
  components: {},
  props: {
    data: Array as PropType<Array<{ label: string; value: string; }>>,
    active: String,
  },
  emits: ['change'],
  setup(props, { emit }) {
    const cur = ref(props.active || props.data?.[0].value || '')

    const change = (t: { label: string; value: string; }) => {
      cur.value = t.value
      emit('change', t)
    }

    watch(() => props.active, newVal => {
      cur.value = newVal
      emit('change', props.data.find(d => d.value === newVal))
    })

    return {
      cur,
      change,
    }
  },
})
</script>
